import React, { useRef, useEffect, useImperativeHandle, forwardRef } from 'react';
import { Grid, Button } from '@mui/material';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import DownloadIcon from '@mui/icons-material/Download';
import { useReactToPrint } from 'react-to-print';
import "../../assets/css/prints.css";
import "../commoncomponents/print.css";
import { useAccess } from "../../AccessContext";
import utilities from '../../utility/utilities';
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import reportslogo from "../../assets/images/reportslogo.png";
import moment from "moment";
import { Troubleshoot } from '@mui/icons-material';
import Licensesummary from './Licensesummary';
import Licensedetails from './Licensedetails';
const Licensedownloadform = forwardRef((props, ref) => {
  const { reportdata, onRenderComplete, setOpenModal, autoDownload, service, reportType, licenseReport, level, licensecategory } = props;
  const printRef = useRef();
  const currentyear = new Date().getFullYear();
  const accessData = useAccess();
  const access = utilities.getScreenPermissions(accessData, "ENGA008");

  useEffect(() => {
    if (onRenderComplete) {
      onRenderComplete();
    }
  }, [onRenderComplete]);

  useEffect(() => {
    if (autoDownload && reportdata) {
      handleDownloadPDF();
      handleExcel();
    }
  }, [reportdata, autoDownload]);
  useEffect(() => {
    if (printRef.current) {
      printRef.current.style.width = '100%';
    }
  }, [reportdata]);


  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    onBeforePrint: () => {
      printRef.current.classList.add('printable-area'); // Apply printable-area class for print
    },
    onAfterPrint: () => {
      printRef.current.classList.remove('printable-area'); // Remove class after print
    },
  });

  const getReportName = (licenseReportValue) => {
    return licenseReportValue === 1
      ? "License Register Detail Report"
      : licenseReportValue === 2
        ? "License Register Summary Report"
        : "License Register Report";
  };

  const handleDownloadPDF = () => {
    const reportName = getReportName(licenseReport.value);

    html2canvas(printRef.current, {
      scale: 2, // Higher scale for better quality
      useCORS: true,
    })
      .then((canvas) => {
        const pdf = new jsPDF({
          orientation: "landscape",
          unit: "mm",
          format: "a4", // A4 size
        });

        // PDF dimensions
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        // Canvas dimensions in mm
        const imgWidth = pdfWidth;
        const imgHeight = (canvas.height * pdfWidth) / canvas.width;

        // Track height and position
        let heightLeft = imgHeight;
        let pageHeight = pdfHeight - 10; // Account for top and bottom margins (10mm total)
        let position = 0;

        while (heightLeft > 0) {
          const canvasSection = document.createElement("canvas");
          const ctx = canvasSection.getContext("2d");

          // Set canvas section dimensions
          canvasSection.width = canvas.width;
          canvasSection.height = Math.min(canvas.height, pageHeight * (canvas.width / pdfWidth));

          // Copy the visible portion of the main canvas to the new canvas section
          ctx.drawImage(
            canvas,
            0,
            position * (canvas.width / pdfWidth),
            canvas.width,
            canvasSection.height,
            0,
            0,
            canvas.width,
            canvasSection.height
          );

          // Convert the section to an image
          const imgData = canvasSection.toDataURL("image/png");

          // Add the image to the PDF
          pdf.addImage(
            imgData,
            "PNG",
            0,
            5, // Start slightly below the top
            imgWidth,
            (canvasSection.height * pdfWidth) / canvas.width // Scale height proportionally
          );

          heightLeft -= pageHeight;
          position += pageHeight;

          // Add a new page if there's more content to display
          if (heightLeft > 0) {
            pdf.addPage();
          }
        }

        // Save the PDF
        pdf.save(`${reportName}.pdf`);
      })
      .catch((error) => {
        console.error("Error generating PDF:", error);
      });
  };

  const handleExcel = async () => {
    const licenseReportValue = licenseReport.value;
    const reportName = getReportName(licenseReportValue);

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(reportName);

    // Set dynamic column widths
    worksheet.columns = new Array(18).fill({ width: 20 });

    // Fetch and insert logo
    const rightLogoImage = await fetch(reportslogo).then(res => res.arrayBuffer());
    const rightLogoId = workbook.addImage({ buffer: rightLogoImage, extension: "png" });

    worksheet.addImage(rightLogoId, {
      tl: { col: 0.1, row: 0.1 },
      ext: { width: 80, height: 80 },
      editAs: "oneCell",
    });

    // Adding Title
    worksheet.mergeCells("A1:J5"); // Merge across the required range
    const titleCell = worksheet.getCell("A1"); // Set content in the first merged cell


    // Assign the title value
    titleCell.value = `${getReportName(licenseReportValue)}\n` +
      `Hospital Master: ${level === 0 ? 'All' : level === 1 ? localStorage.getItem('FacilityName') : ''}\n` +
      `Service: ${service.label}\n` +
      `Year: ${currentyear}`;

    titleCell.font = { size: 15, bold: true };
    titleCell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };


    let headers = [];

    if (licenseReport.value === 1) {
      let headers1 = [];
      let mergedCells = [];

      if (level === 1) {
        headers1 = [
          "No", "Status", "License Number", "Asset Numbers", "Equipment / System Description", "Serial Number", "Model", "Vendor Name", "Vendor Code",
          "Employee Name", "Employee Code", "License Category", "Next Inspection Date", "Expiry Date", "Issue Date", "Remarks"
        ];

        mergedCells = [
          { range: "A6:A7", value: "No" },
          { range: "B6:B7", value: "Status" },
          { range: "C6:C7", value: "License Number" }
        ];

        if (licensecategory.value === 0) {
          mergedCells = mergedCells.concat([
            { range: "D6:D7", value: "Asset Numbers" },
            { range: "E6:E7", value: "Equipment / System Description" },
            { range: "F6:F7", value: "Serial Number" },
            { range: "G6:G7", value: "Model" },
            { range: "H6:H7", value: "Vendor Name" },
            { range: "I6:I7", value: "Vendor Code" },
            { range: "J6:J7", value: "Employee Name" },
            { range: "K6:K7", value: "Employee Code" },
            { range: "L6:L7", value: "License Category" },
            { range: "M6:M7", value: "License Type Code" },
            { range: "N6:N7", value: "Next Inspection Date" },
            { range: "O6:O7", value: "Expiry Date" },
            { range: "P6:P7", value: "Issue Date" },
            { range: "Q6:Q7", value: "Remarks" }
          ]);
        } else if (licensecategory.value === 1) {
          mergedCells = mergedCells.concat([
            { range: "D6:D7", value: "Asset Numbers" },
            { range: "E6:E7", value: "Equipment / System Description" },
            { range: "F6:F7", value: "Serial Number" },
            { range: "G6:G7", value: "Model" },
            { range: "H6:H7", value: "License Category" },
            { range: "I6:I7", value: "License Type Code" },
            { range: "J6:J7", value: "Next Inspection Date" },
            { range: "K6:K7", value: "Expiry Date" },
            { range: "L6:L7", value: "Issue Date" },
            { range: "M6:M7", value: "Remarks" }
          ]);
        } else if (licensecategory.value === 2) {
          mergedCells = mergedCells.concat([
            { range: "D6:D7", value: "Vendor Name" },
            { range: "E6:E7", value: "Vendor Code" },
            { range: "F6:F7", value: "License Category" },
            { range: "G6:G7", value: "License Type Code" },
            { range: "H6:H7", value: "Next Inspection Date" },
            { range: "I6:I7", value: "Expiry Date" },
            { range: "J6:J7", value: "Issue Date" },
            { range: "K6:K7", value: "Remarks" }
          ]);
        } else if (licensecategory.value === 3) {
          mergedCells = mergedCells.concat([
            { range: "D6:D7", value: "Employee Name" },
            { range: "E6:E7", value: "Employee Code" },
            { range: "F6:F7", value: "License Category" },
            { range: "G6:G7", value: "License Type Code" },
            { range: "H6:H7", value: "Next Inspection Date" },
            { range: "I6:I7", value: "Expiry Date" },
            { range: "J6:J7", value: "Issue Date" },
            { range: "K6:K7", value: "Remarks" }
          ]);
        }

      } else if (level === 0) {
        headers1 = [
          "No", "Hospital", "Status", "License Number", "Asset Numbers", "Equipment / System Description", "Serial Number", "Model", "Vendor Name", "Vendor Code",
          "Employee Name", "Employee Code", "License Category", "Next Inspection Date", "Expiry Date", "Issue Date", "Remarks"
        ];

        mergedCells = [
          { range: "A6:A7", value: "No" },
          { range: "B6:B7", value: "Hospital" },
          { range: "C6:C7", value: "Status" },
          { range: "D6:D7", value: "License Number" }
        ];

        if (licensecategory.value === 0) {
          mergedCells = mergedCells.concat([
            { range: "E6:E7", value: "Asset Numbers" },
            { range: "F6:F7", value: "Equipment / System Description" },
            { range: "G6:G7", value: "Serial Number" },
            { range: "H6:H7", value: "Model" },
            { range: "I6:I7", value: "Vendor Name" },
            { range: "J6:J7", value: "Vendor Code" },
            { range: "K6:K7", value: "Employee Name" },
            { range: "L6:L7", value: "Employee Code" },
            { range: "M6:M7", value: "License Category" },
            { range: "N6:N7", value: "License Type Code" },
            { range: "O6:O7", value: "Next Inspection Date" },
            { range: "P6:P7", value: "Expiry Date" },
            { range: "Q6:Q7", value: "Issue Date" },
            { range: "R6:R7", value: "Remarks" }
          ]);
        } else if (licensecategory.value === 1) {
          mergedCells = mergedCells.concat([
            { range: "E6:E7", value: "Asset Numbers" },
            { range: "F6:F7", value: "Equipment / System Description" },
            { range: "G6:G7", value: "Serial Number" },
            { range: "H6:H7", value: "Model" },
            { range: "I6:I7", value: "License Category" },
            { range: "J6:J7", value: "License Type Code" },
            { range: "K6:K7", value: "Next Inspection Date" },
            { range: "L6:L7", value: "Expiry Date" },
            { range: "M6:M7", value: "Issue Date" },
            { range: "N6:N7", value: "Remarks" }
          ]);
        } else if (licensecategory.value === 2) {
          mergedCells = mergedCells.concat([
            { range: "E6:E7", value: "Vendor Name" },
            { range: "F6:F7", value: "Vendor Code" },
            { range: "G6:G7", value: "License Category" },
            { range: "H6:H7", value: "License Type Code" },
            { range: "I6:I7", value: "Next Inspection Date" },
            { range: "J6:J7", value: "Expiry Date" },
            { range: "K6:K7", value: "Issue Date" },
            { range: "L6:L7", value: "Remarks" }
          ]);
        } else if (licensecategory.value === 3) {
          mergedCells = mergedCells.concat([
            { range: "E6:E7", value: "Employee Name" },
            { range: "F6:F7", value: "Employee Code" },
            { range: "G6:G7", value: "License Category" },
            { range: "H6:H7", value: "License Type Code" },
            { range: "I6:I7", value: "Next Inspection Date" },
            { range: "J6:J7", value: "Expiry Date" },
            { range: "K6:K7", value: "Issue Date" },
            { range: "L6:L7", value: "Remarks" }
          ]);
        } else if (licensecategory.value === 4) {
          mergedCells = mergedCells.concat([
            { range: "E6:E7", value: "License Category" },
            { range: "F6:F7", value: "License Type Code" },
            { range: "G6:G7", value: "Next Inspection Date" },
            { range: "H6:H7", value: "Expiry Date" },
            { range: "I6:I7", value: "Issue Date" },
            { range: "J6:J7", value: "Remarks" }
          ]);
        }
      }

      // Apply merged cells
      mergedCells.forEach(({ range, value }) => {
        worksheet.mergeCells(range);
        let cell = worksheet.getCell(range.split(":")[0]);
        cell.value = value;
        cell.font = { bold: true };
        cell.alignment = { vertical: "middle", horizontal: "center" };
      });
    }



    const applyMergingAndFormatting = (worksheet, mergedCells) => {
      mergedCells.forEach(({ range, value }) => {
        worksheet.mergeCells(range);
        const cell = worksheet.getCell(range.split(":")[0]); // Get first cell in range
        cell.value = value;
        cell.font = { bold: true };
        cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
        cell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
      });
    };

    const applyBordersToDataCells = (worksheet, startRow, totalColumns) => {
      const endRow = worksheet.lastRow ? worksheet.lastRow.number : startRow;
      for (let row = startRow; row <= endRow; row++) {
        for (let col = 1; col <= totalColumns; col++) {
          const cell = worksheet.getCell(row, col);
          cell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
        }
      }
    };

    if (licenseReport.value === 2) {
      if (level === 1) {
        headers = ["No", "License Number", "License Category", "License Type Code", "License Type Description", "Issue Date", "Next Inspection Date", "Expiry Date", "Remarks", "Status"];

        const mergedCells = [
          { range: "A6:A7", value: "No" },
          { range: "B6:B7", value: "License Number" },
          { range: "C6:C7", value: "License Category" },
          { range: "D6:D7", value: "License Type Code" },
          { range: "E6:E7", value: "License Type Description" },
          { range: "F6:F7", value: "Issue Date" },
          { range: "G6:G7", value: "Next Inspection Date" },
          { range: "H6:H7", value: "Expiry Date" },
          { range: "I6:I7", value: "Remarks" },
          { range: "J6:J7", value: "Status" }
        ];

        applyMergingAndFormatting(worksheet, mergedCells);

        applyBordersToDataCells(worksheet, 8, headers.length);
      } else if (level === 0) {
        headers = ["No", "Hospital", "License Number", "License Category", "License Type Code", "License Type Description", "Issue Date", "Next Inspection Date", "Expiry Date", "Remarks", "Status"];

        const mergedCells = [
          { range: "A6:A7", value: "No" },
          { range: "B6:B7", value: "Hospital" },
          { range: "C6:C7", value: "License Number" },
          { range: "D6:D7", value: "License Category" },
          { range: "E6:E7", value: "License Type Code" },
          { range: "F6:F7", value: "License Type Description" },
          { range: "G6:G7", value: "Issue Date" },
          { range: "H6:H7", value: "Next Inspection Date" },
          { range: "I6:I7", value: "Expiry Date" },
          { range: "J6:J7", value: "Remarks" },
          { range: "K6:K7", value: "Status" }
        ];

        applyMergingAndFormatting(worksheet, mergedCells);
        applyBordersToDataCells(worksheet, 8, headers.length);
      }
    }



    // Insert Data starting from Row 8
    let rowIndex = 8;
    let serialNumber = 1; // Move serialNumber outside to keep incrementing across all licenses

    if (reportdata?.length) {
      reportdata.forEach((license, licenseIndex) => {

        // Check if `licenseReport.value === 1`
        if (licenseReport.value === 1) {
          let rowData = [];

          // Handle the logic based on the `level` value
          if (level === 1) {
            // Process license object directly for level 1
            rowData = [
              serialNumber++, // Increment serialNumber correctly across all licenses
              license.licensestatus,
              license.licenseno,
              ...(licensecategory.value === 0 ? [
                license.assetno || '',
                license.assetdesc || '',
                license.serialno || '',
                license.model || '',
                license.vendorname || '',
                license.vendorcode || '',
                license.employeename || '',
                license.employeecode || '',
                license.licensecategory || '',
                license.licensetypecode || '',
                license.nextinspectiondate || '',
                license.expirydate || '',
                license.issuedate || '',
                license.remarks || ''
              ] : []),
              ...(licensecategory.value === 1 ? [
                license.assetno || '',
                license.assetdesc || '',
                license.serialno || '',
                license.model || '',
                license.licensecategory || '',
                license.licensetypecode || '',
                license.nextinspectiondate || '',
                license.expirydate || '',
                license.issuedate || '',
                license.remarks || ''
              ] : []),
              ...(licensecategory.value === 2 ? [
                license.vendorname || '',
                license.vendorcode || '',
                license.licensecategory || '',
                license.licensetypecode || '',
                license.nextinspectiondate || '',
                license.expirydate || '',
                license.issuedate || '',
                license.remarks || ''
              ] : []),
              ...(licensecategory.value === 3 ? [
                license.employeename || '',
                license.employeecode || '',
                license.licensecategory || '',
                license.licensetypecode || '',
                license.nextinspectiondate || '',
                license.expirydate || '',
                license.issuedate || '',
                license.remarks || ''
              ] : []),
              ...(licensecategory.value === 4 ? [
                license.licensecategory || '',
                license.licensetypecode || '',
                license.nextinspectiondate || '',
                license.expirydate || '',
                license.issuedate || '',
                license.remarks || ''
              ] : [])

            ];

          } else if (level === 0) {
            // Process license object directly for level 0
            rowData = [
              serialNumber++, // Increment serialNumber correctly across all licenses
              license.hospital || '',
              license.licensestatus,
              license.licenseno,
              ...(licensecategory.value === 0 ? [
                license.assetno || '',
                license.assetdesc || '',
                license.serialno || '',
                license.model || '',
                license.vendorname || '',
                license.vendorcode || '',
                license.employeename || '',
                license.employeecode || '',
                license.licensecategory || '',
                license.licensetypecode || '',
                license.nextinspectiondate || '',
                license.expirydate || '',
                license.issuedate || '',
                license.remarks || ''
              ] : []),
              ...(licensecategory.value === 1 ? [
                license.assetno || '',
                license.assetdesc || '',
                license.serialno || '',
                license.model || '',
                license.licensecategory || '',
                license.licensetypecode || '',
                license.nextinspectiondate || '',
                license.expirydate || '',
                license.issuedate || '',
                license.remarks || ''
              ] : []),
              ...(licensecategory.value === 2 ? [
                license.vendorname || '',
                license.vendorcode || '',
                license.licensecategory || '',
                license.licensetypecode || '',
                license.nextinspectiondate || '',
                license.expirydate || '',
                license.issuedate || '',
                license.remarks || ''
              ] : []),
              ...(licensecategory.value === 3 ? [
                license.employeename || '',
                license.employeecode || '',
                license.licensecategory || '',
                license.licensetypecode || '',
                license.nextinspectiondate || '',
                license.expirydate || '',
                license.issuedate || '',
                license.remarks || ''
              ] : []),
              ...(licensecategory.value === 4 ? [
                license.licensecategory || '',
                license.licensetypecode || '',
                license.nextinspectiondate || '',
                license.expirydate || '',
                license.issuedate || '',
                license.remarks || ''
              ] : [])

            ];
          }

          // Add rowData to the Excel sheet if it has content
          if (rowData.length) {

            const excelRow = worksheet.getRow(rowIndex);
            excelRow.values = rowData;

            rowIndex++; // Move to the next row in Excel
          }
        }

        // Handle `licenseReport.value === 2` for different level logic
        else if (licenseReport.value === 2) {
          if (level === 1) {
            // Process for level 0 in licenseReport.value === 2
            const rowData = [
              licenseIndex + 1,
              license.licenseno || '',
              license.licensecategory || '',
              license.licensetypecode || '',
              license.licensetypecodedesc || '',
              license.issuedate || '',
              license.nextinspectiondate || '',
              license.expirydate || '',
              license.remarks || '',
              license.licensestatus
            ];
            const excelRow = worksheet.getRow(rowIndex);
            excelRow.values = rowData;

           
            rowIndex++; // Move to the next row in Excel
          } else if (level === 0) {
            // Process for level 1 in licenseReport.value === 2
            const rowData = [
              licenseIndex + 1,
              license.hospital || '',
              license.licenseno || '',
              license.licensecategory || '',
              license.licensetypecode || '',
              license.licensetypecodedesc || '',
              license.issuedate || '',
              license.nextinspectiondate || '',
              license.expirydate || '',
              license.remarks || '',
              license.licensestatus
            ];
            const excelRow = worksheet.getRow(rowIndex);
            excelRow.values = rowData;

            rowIndex++; // Move to the next row in Excel
          }
        }
      });
    }




    worksheet.eachRow(row => {
      row.eachCell(cell => {
        cell.border = {
          top: { style: "thin", color: { argb: "000000" } },
          left: { style: "thin", color: { argb: "000000" } },
          bottom: { style: "thin", color: { argb: "000000" } },
          right: { style: "thin", color: { argb: "000000" } }
        };
      });
    });

    try {
      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(new Blob([buffer]), `${getReportName(licenseReportValue)}.xlsx`);

    } catch (error) {
      console.error("Error while saving Excel file:", error);
    }
  };


  const handleClose = () => {
    setOpenModal(false);
  };

  useImperativeHandle(ref, () => ({
    handleDownloadPDF,
    handleExcel
  }));

  useEffect(() => {
  }, [licenseReport, reportdata, service]);

  return (
    <>
      <Grid container justifyContent="flex-end" spacing={2} >
        {access?.canPrint && (<>
          <Grid item>
            <Button variant="contained" onClick={handlePrint}>Print</Button>
          </Grid>
          {/* <Grid item>
            <Button variant='contained'
              startIcon={<DownloadIcon />}
              style={{ marginRight: '8px' }} onClick={handleDownloadPDF}>PDF</Button>

          </Grid> */}
          <Grid item>
            <Button
              variant="contained"
              onClick={handleExcel}
              startIcon={<InsertDriveFileIcon />}
              style={{ marginRight: '8px' }}
            >
              XLSX
            </Button>

          </Grid>
        </>)}
        <Grid item>
          <Button variant="contained" onClick={handleClose}>Close</Button>
        </Grid>
      </Grid>



      <div ref={printRef} className="print-content" style={{ overflow: 'visible' }} >
        {licenseReport?.value === 2 ? (
          <>

            <Licensesummary reportType={reportType} reportdata={reportdata} service={service} level={level} licensecategory={licensecategory} />
          </>
        ) : (
          <>

            <Licensedetails reportdata={reportdata} service={service} reportType={reportType} level={level} licensecategory={licensecategory} />
          </>
        )}
      </div>
    </>
  );
});

export default Licensedownloadform;
